<template>
  <ErrorComponent/>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent.vue";

export default {
    name: "ErrorPage",
    components: {
        ErrorComponent
    }
}
</script>

<style>

</style>